<body [ngClass]="{'waiting': loading_data} ">
  <cdk-virtual-scroll-viewport (scroll)="scrolled($event)" itemSize="16" class="example-viewport">
    <div [style.top]="inverseOfTranslation" class="sticky-header box">
      <div>
        <div class="header-first xxsmall">Box</div>
        <div class="header small">UID</div>
        <div class="header small">JobID</div>
        <div class="header medium">Hub Serial</div>
        <div class="header medium">Old Index</div>
        <div class="header xlarge">Email</div>
        <div class="header small">Duplicate</div>
        <div class="header medium">Phone</div>
        <div class="header large">Name</div>
        <div class="header medium">Fuel Type</div>
        <div class="header small">Approved</div>
        <div class="header xlarge">Comment</div>
        <div class="header small">Source</div>
        <div class="header xxlarge">Address</div>
        <div class="header small">Eircode</div>
        <div class="header small">City</div>
        <div class="header small">Have Wifi?</div>
        <div class="header small">Pre2007?</div>
        <div class="header small">Grant?</div>
        <div class="header small">Time Clock?</div>
        <div class="header medium">MPRN</div>
        <div class="header medium">GPRN</div>
        <div class="header small">BER</div>
        <div class="header large">Created</div>
        <div class="header small">Batch</div>
        <div class="header large">Handed to Installer</div>
        <div class="header large">Heating System</div>
        <div class="header large">Lead Status</div>
        <div class="header small">Dead</div>
        <div class="header small">Removed</div>
        <div class="header large">Installer</div>
        <div class="header medium">Company</div>
        <div class="header large">Last Geopal Update</div>
        <div class="header large">Geopal Status</div>
      </div>
      <div>
        <div class="search-first xxsmall">
          <div class="flex-item-4">
            <!--input matInput placeholder="Filter" class="input-style-1" [(ngModel)]="searchParams.ecms_id"-->
            <input matInput placeholder="Filter" class="input-style-1">
            <mat-checkbox [(ngModel)]="checkAll" (change)="masterBox()"></mat-checkbox>
          </div>
        </div>
        <div class="search small">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.uid">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('uid')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search small">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.job_id">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('job_id')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search medium">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.serial_number">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('serial_no')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search medium">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.master_sheet_index">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('master_sheet_index')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search xlarge">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.email">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('email')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search small">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="tempDup">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('duplicate')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search medium">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.phone">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('phone')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search large">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.full_name">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('full_name')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search medium">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.fuel_type">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('fuel_type')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search small">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="tempApp">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('approved')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search xlarge">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput class="input-style" [(ngModel)]="searchParams.comment">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('comment')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search small">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.source">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('source')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search xxlarge">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.address">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('address')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search small">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.eircode">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('postcode')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search small">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.city">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('city')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search small">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [attr.disabled]="true" [(ngModel)]="tempWifi">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('wifi')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search small">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [attr.disabled]="true" [(ngModel)]="temp2007">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('pre2007')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search small">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [attr.disabled]="true" [(ngModel)]="tempGrant">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('grant')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search small">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [attr.disabled]="true" [(ngModel)]="tempTime">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('timeclock')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search medium">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.mprn">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('mprn')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search medium">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.gprn">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('gprn')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search small">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.ber">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('ber')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search large">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.created">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('created')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search small">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.installation_batch">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('batch')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search large">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.handed_to_installer">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('handed_to_installer')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search large">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.heating_system_name">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('heatingsystem')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search large">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.lead_status_name">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('leadstatus')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search small">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="tempDead">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('dead')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search small">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="tempRm">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('removed')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search large">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.installer_name">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('installer')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search medium">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style"
                [(ngModel)]="searchParams.installer_company_name">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('company_name')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search large">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style"
                [(ngModel)]="searchParams.last_updated_date_time">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('last_geopal_update')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search large">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.geopal_status">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('geopal_status')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row box" *cdkVirtualFor="let lead of leadList; let index = index"
      [style.background-color]="this.getColor(index)">
    <div class="column-first xxsmall">
        <mat-checkbox [checked]="checkForVal(lead.uid)" (change)="addId(lead.uid)"></mat-checkbox>
      </div>
      <div class="column small">{{lead.uid}}</div>
      <div class="column small">
        <input matInput class="small_input" id="next_job_id" (keyup.enter)="keytab($event)"
          (change)="updateLeads(lead.uid, lead.job_id, $event.srcElement.id)" [value]="lead.job_id"
          [(ngModel)]="lead.job_id"></div>
      <div class="column medium">
        <input matInput class="medium_input" id="next_serial" (keyup.enter)="keytab($event)"
          (change)="updateLeads(lead.uid, lead.serial_number, $event.srcElement.id)" [value]="lead.serial_number"
          [(ngModel)]="lead.serial_number"></div>
      <div class="column medium">{{lead.master_sheet_index}}</div>
      <div class="column xlarge">
        <input matInput class="xlarge_input" id="next_email" (keyup.enter)="keytab($event)"
          (change)="updateLeads(lead.uid, lead.email, $event.srcElement.id)" [value]="lead.email"
          [(ngModel)]="lead.email"></div>
      <div class="column small">
        <mat-select class="small_input" id="next_duplicate" [(ngModel)]="lead.duplicate"
          (selectionChange)="updateLeads(lead.uid, lead.duplicate, $event.source._id)">
          <mat-option *ngFor="let a of truefalse" [value]="a.type">{{ a.name }}
          </mat-option>
        </mat-select>
      </div>
      <div class="column medium">
        <input matInput class="medium_input" id="next_phone" (keyup.enter)="keytab($event)"
          (change)="updateLeads(lead.uid, lead.phone, $event.srcElement.id)" [value]="lead.phone"
          [(ngModel)]="lead.phone"></div>
      <div class="column large">
        <input matInput class="large_input" id="next_name" (keyup.enter)="keytab($event)"
          (change)="updateLeads(lead.uid, lead.full_name, $event.srcElement.id)" [value]="lead.full_name"
          [(ngModel)]="lead.full_name"></div>
      <div class="column medium">
        <mat-select class="medium_input" id="next_fuel_type" [(ngModel)]="lead.fuel_type"
          (selectionChange)="updateLeads(lead.uid, lead.fuel_type, $event.source._id)">
          <ng-container *ngFor="let fuel of fuels">
            <mat-option [value]="fuel.id">{{ fuel.type }}
            </mat-option>
          </ng-container>
        </mat-select>
      </div>
      <div class="column small">
        <mat-select class="small_input" id="next_approved" [(ngModel)]="lead.approved"
          (selectionChange)="updateLeads(lead.uid, lead.approved, $event.source._id)">
          <mat-option *ngFor="let a of truefalse" [value]="a.type">{{ a.name }}
          </mat-option>
        </mat-select>
      </div>
      <div class="column xlarge">
        <input matInput class="xlarge_input" id="next_comment" (keyup.enter)="keytab($event)"
          (change)="updateLeads(lead.uid, lead.comment, $event.srcElement.id)" [value]="lead.comment"
          [(ngModel)]="lead.comment"></div>
      <div class="column small">
        <input matInput class="small_input" id="next_source" (keyup.enter)="keytab($event)"
          (change)="updateLeads(lead.uid, lead.source, $event.srcElement.id)" [value]="lead.source"
          [(ngModel)]="lead.source"></div>
      <div class="column xxlarge">
        <input matInput class="xxlarge_input" id="next_address" (keyup.enter)="keytab($event)"
          (change)="updateLeads(lead.uid, lead.address, $event.srcElement.id)" [value]="lead.address"
          [(ngModel)]="lead.address"></div>
      <div class="column small">
        <input matInput class="small_input" id="next_eircode" (keyup.enter)="keytab($event)"
          (change)="updateLeads(lead.uid, lead.eircode, $event.srcElement.id)" [value]="lead.eircode"
          [(ngModel)]="lead.eircode"></div>
      <div class="column small">
        <input matInput class="small_input" id="next_city" (keyup.enter)="keytab($event)"
          (change)="updateLeads(lead.uid, lead.city, $event.srcElement.id)" [value]="lead.city" [(ngModel)]="lead.city">
      </div>
      <div class="column small">
        <mat-select class="small_input" id="next_wifi" [(ngModel)]="lead.have_wifi"
          (selectionChange)="updateLeads(lead.uid, lead.have_wifi, $event.source._id)">
          <mat-option *ngFor="let a of truefalse" [value]="a.type">{{ a.name }}
          </mat-option>
        </mat-select>
      </div>
      <div class="column small">
        <mat-select class="small_input" id="next_pre2007" [(ngModel)]="lead.built_before_2007"
          (selectionChange)="updateLeads(lead.uid, lead.built_before_2007, $event.source._id)">
          <mat-option *ngFor="let a of truefalse" [value]="a.type">{{ a.name }}
          </mat-option>
        </mat-select>
      </div>
      <div class="column small">
        <mat-select class="small_input" id="next_grant" [(ngModel)]="lead.previous_grant"
          (selectionChange)="updateLeads(lead.uid, lead.previous_grant, $event.source._id)">
          <mat-option *ngFor="let a of truefalse" [value]="a.type">{{ a.name }}
          </mat-option>
        </mat-select>
      </div>
      <div class="column small">
        <mat-select class="small_input" id="next_timeclock" [(ngModel)]="lead.use_time_clock"
          (selectionChange)="updateLeads(lead.uid, lead.use_time_clock, $event.source._id)">
          <mat-option *ngFor="let a of truefalse" [value]="a.type">{{ a.name }}
          </mat-option>
        </mat-select>
      </div>
      <div class="column medium">
        <input matInput class="medium_input" id="next_mprn" (keyup.enter)="keytab($event)"
          (change)="updateLeads(lead.uid, lead.mprn, $event.srcElement.id)" [value]="lead.mprn" [(ngModel)]="lead.mprn">
      </div>
      <div class="column medium">
        <input matInput class="medium_input" id="next_gprn" (keyup.enter)="keytab($event)"
          (change)="updateLeads(lead.uid, lead.gprn, $event.srcElement.id)" [value]="lead.gprn" [(ngModel)]="lead.gprn">
      </div>
      <div class="column small">
        <input matInput class="small_input" id="next_ber" (keyup.enter)="keytab($event)"
          (change)="updateLeads(lead.uid, lead.ber, $event.srcElement.id)" [value]="lead.ber" [(ngModel)]="lead.ber">
      </div>
      <div class="column large">{{lead.created}}</div>
      <div class="column small">
        <input matInput class="small_input" id="next_installation_batch" (keyup.enter)="keytab($event)"
          (change)="updateLeads(lead.uid, lead.installation_batch, $event.srcElement.id)"
          [value]="lead.installation_batch" [(ngModel)]="lead.installation_batch"></div>
      <div class="column large">
        <input matInput class="large_input" id="next_handed_to_installer" (keyup.enter)="keytab($event)"
          (change)="updateLeads(lead.uid, lead.handed_to_installer, $event.srcElement.id)"
          [value]="lead.handed_to_installer" [(ngModel)]="lead.handed_to_installer"></div>
      <div class="column large">
        <mat-select id="next_heating_system" [(ngModel)]="lead.heating_system_id"
          (selectionChange)="updateLeads(lead.uid, lead.heating_system_id, $event.source._id)">
          <ng-container *ngFor="let system of heatingSystemList">
            <mat-option [value]="system.heating_system_id">
              {{ system.heating_system_name }}
            </mat-option>
          </ng-container>
        </mat-select>
      </div>
      <div class="column large">
        <mat-select id="next_lead_status" [(ngModel)]="lead.lead_status_id"
          (selectionChange)="updateLeads(lead.uid, lead.lead_status_id, $event.source._id)">
          <ng-container *ngFor="let status of statusList">
            <mat-option [value]="status.lead_status_id">
              {{ status.lead_status_name }}
            </mat-option>
          </ng-container>
        </mat-select>
      </div>
      <div class="column small">
        <mat-select class="small_input" id="next_dead" [(ngModel)]="lead.dead_lead"
          (selectionChange)="updateLeads(lead.uid, lead.dead_lead, $event.source._id)">
          <mat-option *ngFor="let a of truefalse" [value]="a.type">{{ a.name }}
          </mat-option>
        </mat-select>
      </div>
      <div class="column small">
        <mat-select class="small_input" id="next_removed" [(ngModel)]="lead.removed"
          (selectionChange)="updateLeads(lead.uid, lead.removed, $event.source._id)">
          <mat-option *ngFor="let a of truefalse" [value]="a.type">{{ a.name }}
          </mat-option>
        </mat-select>
      </div>
      <div class="column large">
        <input matInput class="large_input" id="next_installer" (keyup.enter)="keytab($event)"
          (change)="updateLeads(lead.uid, lead.installerid, $event.srcElement.id)" [value]="lead.installerid"
          [(ngModel)]="lead.installerid"></div>
      <div class="column medium">{{getName(lead.installer_company_name)}}</div>
      <div class="column large">{{lead.last_updated_date_time}}</div>
      <div class="column large">{{lead.geopal_status}}</div>
    </div>
  </cdk-virtual-scroll-viewport>
</body>
